import { isSSR } from '@helpers/ssr';
import { FocusScope } from '@react-aria/focus';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Background from './Background/Background';
import Close from './Close/Close';
import { ModalProvider } from './Context/Context';
import S from './Modal.styles';
const Modal = (props) => {
    if (isSSR() || !props.isOpen) {
        return null;
    }
    // Use #root if available, otherwise fallback to body.
    const portalContainer = document.getElementById('root') ?? document.body;
    const portalContent = (React.createElement(ModalProvider, { closeOnBackground: props.closeOnBackground, showBackground: props.showBackground, showClose: props.showClose, onClose: props.onClose, site: props.site },
        React.createElement(FocusScope, { autoFocus: true, contain: true, restoreFocus: true },
            React.createElement(S.Container, { id: props.id, role: "dialog", "aria-label": props.ariaLabel, site: props.site, spacing: "none", layout: "fullWidth", "aria-modal": "true", tabIndex: -1, onKeyDown: (event) => {
                    if (props.onClose && props.showClose && event.key === 'Escape') {
                        props.onClose();
                    }
                }, "data-type": props.type },
                props.showBackground && React.createElement(Background, null),
                React.createElement(S.Inner, null,
                    props.children,
                    props.showClose && React.createElement(Close, { site: props.site }))))));
    return ReactDOM.createPortal(portalContent, portalContainer);
};
export default Modal;
